<template>
<div>
<navigation></navigation>
<div class="box_center" id="page_x">
  <h2 class="shadow" style="float: left">Testimonials</h2>
  <ul class="articles">
    <li v-for="test in testimonials">
      <div class="article">
        <p class="text_article">{{test.content}}</p>
        <cite>{{test.author}}, &nbsp;<b>{{test.type}}</b></cite>
      </div>
      <div class="separator"></div>
    </li>
  </ul>
  <adsense
      ad-client="ca-pub-8213113866781504"
      ad-slot="7783278999"
      ad-layout-key="-8i+1w-dq+e9+ft"
      ad-format="fluid">
  </adsense>
</div>
</div>
</template>

<script>
import Nav from '../components/Nav'
import TestimonialRepository from '../data/testimonial.repository'
import Adsense from '../components/adsense.vue'
export default {
  components: {
    'navigation': Nav,
    'adsense': Adsense
  },
  data () {
    return {
      testimonials: []
    }
  },
  created () {
    TestimonialRepository.getTestimonials().then((testimonials) => {
      this.testimonials = testimonials
    })
  },
  metaInfo: {
    title: 'Testimonials'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Testimonials.vue?528f6f1d